import { useQuery } from "@tanstack/react-query";
import api from "../utils/api/axiosInstance";

export function useSuggestedUsers({ limit = 5, enabled = true } = {}) {
  return useQuery({
    queryKey: ["suggestedUsers", limit],
    queryFn: async () => {
      const res = await api.get("/users/discover", { params: { limit } });
      return res.data.users || [];
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
